import { HorizontalContainer, IconButton, WholeNumberInput } from '@american-autonomy/ag-ui';

import MinusIcon from 'components/icons/MinusIcon';
import PlusIcon from 'components/icons/PlusIcon';

import {
    DECREMENT_BUTTON_TEST_ID,
    DEFAULT_STEP,
    INCREMENT_BUTTON_TEST_ID,
    TEST_ID,
    VALUE_INPUT_TEST_ID
} from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const StepperInput: FunctionComponent<Props> = ({
    className = '',
    isDisabled = false,
    max,
    min,
    name,
    onChange,
    step = DEFAULT_STEP,
    testId = TEST_ID,
    value
}) => {
    const currentValue = Number.isFinite(value) ? (value as number) : min;

    const handleStep = (offset: number) => () =>
        onChange(Math.min(Math.max(currentValue + offset, min), max));

    return (
        <HorizontalContainer className={`${className} ${styles.stepperInput}`} testId={testId}>
            <IconButton
                className={styles.stepButton}
                isDisabled={isDisabled || currentValue <= min}
                onClick={handleStep(-step)}
                testId={DECREMENT_BUTTON_TEST_ID}>
                <MinusIcon />
            </IconButton>

            <WholeNumberInput
                className={styles.valueInput}
                isDisabled={isDisabled}
                name={name}
                onChange={onChange}
                testId={VALUE_INPUT_TEST_ID}
                value={value}
            />

            <IconButton
                className={styles.stepButton}
                isDisabled={isDisabled || currentValue >= max}
                onClick={handleStep(step)}
                testId={INCREMENT_BUTTON_TEST_ID}>
                <PlusIcon />
            </IconButton>
        </HorizontalContainer>
    );
};

export default StepperInput;
